import React, { Component } from 'react';
import classnames from 'classnames';
import {Col, Row, MenuItem, DropdownButton} from 'react-bootstrap';
import Redux from 'redux';

class FileDropdownSidebarView extends Component {

    handleChange = (e) => {
        let value = e.target && e.target.value;
        if (!value) {
            return;
        }
        var queryTerm = {};
        var type = this.props && this.props.type;
        queryTerm[type] = value;
        this.props.handleChange(queryTerm);
    }

    renderItems() {
        return this.props.keys.map(function(item) {
            return <option className="col-xs-12" key={item.key} value={item.key}>{item.displayName}</option>;
        }, this);
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="form-group">
                    <span className="community-sidebar-input-title">{this.props.name}</span>
                </Col>
                <Col xs={12}>
                    <select id="filter-dropdown" title="Please Select a Filter"
                        className="col-xs-12"
                        onChange={this.handleChange}>
                        {this.renderItems()}
                    </select>
                </Col>
            </Row>
        );
    }
}
export default FileDropdownSidebarView;

